import keyBy from 'lodash.keyby';
import { CONTESTS_SHOW_SUCCESS } from '../actions/contests';

const defaultState = {};

export default (state = defaultState, { type, payload = {} }) => {
  switch (type) {
    case CONTESTS_SHOW_SUCCESS: {
      return keyBy(payload.contests, 'externalId');
    }

    default: {
      return state;
    }
  }
};
